var path = '/templates/projects.segments/campaign_segment_show_custom.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.segments/campaign_segment_show_custom.html
// module id = 1444
// module chunks = 0